const formEl = document.querySelector('#careers-form');
const fullNameEl = document.querySelector('#full-name');
const applyingForEl = document.querySelector('#applying-for');
const resumeEl = document.querySelector('#resume');
const emailEl = document.querySelector('#email');
const phoneNumberEl = document.querySelector('#phone-number');
const workExperienceDetailsEl = document.querySelector('#work-experience-details');
const educationEl = document.querySelector('#education');
const submitButtonEl = document.querySelector('#submit-careers-form-button');
const successMessageEl = document.querySelector('#success-message');

(() => {
  const jobTitleElems = document.querySelectorAll('#job-listing-container h3.Heading.u-h4');
  const jobTitles = Array.from(jobTitleElems).map((elem) => elem.textContent.trim());

  jobTitles.forEach((title) => {
    const optionEl = document.createElement('option');
    optionEl.value = title;
    optionEl.textContent = title;
    applyingForEl.appendChild(optionEl);
  });
})();

resumeEl.addEventListener('change', () => {
  resumeEl.setCustomValidity('');
});

async function handleFormSubmit(event) {
  event.preventDefault();
  submitButtonEl.disabled = true;

  const full_name = fullNameEl.value.trim();
  const employment_status = document.querySelector('input[name="employment-status"]:checked').value;
  const applying_for = applyingForEl.value.trim();
  const can_work_in_office = document.querySelector('input[name="can-work-in-office"]:checked').value === 'true';
  const resume = resumeEl.files[0];
  const email = emailEl.value.trim();
  const phone_number = phoneNumberEl.value.trim();
  const has_relevant_experience = document.querySelector('input[name="work-experience"]:checked').value === 'true';
  const experience_details = workExperienceDetailsEl.value.trim();
  const education_level = educationEl.value.trim();

  if (resume) {
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (resume.size > maxSize) {
      const errorMsg = 'The file size is too large. Please upload a file that is less than 5MB.';
      resumeEl.setCustomValidity(errorMsg);
      resumeEl.reportValidity();
      submitButtonEl.disabled = false;
      return;
    } else {
      // Clear any previous custom validation messages
      resumeEl.setCustomValidity('');
    }
  }

  if (
    full_name &&
    employment_status &&
    applying_for &&
    resume &&
    email &&
    phone_number &&
    experience_details &&
    education_level
  ) {
    const formData = new FormData();
    formData.append('full_name', full_name);
    formData.append('employment_status', employment_status);
    formData.append('applying_for', applying_for);
    formData.append('can_work_in_office', can_work_in_office);
    formData.append('resume', resume);
    formData.append('email', email);
    formData.append('phone_number', phone_number);
    formData.append('has_relevant_experience', has_relevant_experience);
    formData.append('experience_details', experience_details);
    formData.append('education_level', education_level);

    const originUrl = window.location.origin;
    const apiUrl = originUrl === 'https://kiarasky.com' ? 'https://sleepy-ridge-54731-86f3fc602d40.herokuapp.com' : 'http://localhost:8080';

    try {
      const response = await fetch(`${apiUrl}/api/careers/applications`, {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        successMessageEl.classList.remove('d-none');
        formEl.classList.add('d-none');
        formEl.reset();
      } else {
        alert('An error occurred. Please try again.');
        submitButtonEl.disabled = false;
      }
    } catch (error) {
      alert('An error occurred. Please try again.');
      submitButtonEl.disabled = false;
    }
  }
}

formEl.addEventListener('submit', handleFormSubmit);